import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext, useState } from 'react';
import ThemeContext from '../../../providers/ThemeProvider';

const Tooltip = ({ children, extraClasses, iconText }) => {
  const theme = useContext(ThemeContext);
  const isTouch = 'ontouchstart' in window;
  const [isToggled, setToggled] = useState(false);
  const toggle = () => {
    setToggled(!isToggled);
  };

  return (
    <>
      <div
        {...(isTouch && { onClick: toggle })}
        className={classNames('tool-tip', extraClasses)}
      >
        <p className="tool-tip__i">{iconText}</p>
        <div
          className={classNames('tool-tip__text', {
            'tool-tip__is-enabled': isToggled,
          })}
        >
          {children}
        </div>
      </div>
      <style jsx>{`
        .tool-tip {
          display: inline-block;
          vertical-align: middle;
          position: relative;
          background-color: ${theme.colors.primary};
          height: 18px;
          width: 18px;
          border-radius: 50%;
          text-align: center;
          font-size: 1.3rem;
          top: -2px;
        }
        .tool-tip__i {
          font-size: 1.4rem;
          position: absolute;
          color: ${theme.colors.white};
          font-weight: 800;
          font-style: italic;
          font-family: Cambria, Cochin, Georgia, Times, Times New Roman, serif;
          margin: -2px 6px;
        }
        .tool-tip:focus,
        .tool-tip__i:focus {
          outline: 0;
        }
        .tool-tip__text {
          visibility: hidden;
          top: 28px;
          display: inline-block;
          left: -120px;
          width: 200px;
          background-color: ${theme.colors.primary};
          border: 1px solid ${theme.colors.white};
          color: ${theme.colors.white};
          text-align: center;
          border-radius: 6px;
          padding: 10px;
          box-shadow: 0 0 4px #bababa;
          position: absolute;
          z-index: 1;
        }
        .tool-tip__text:before,
        .tool-tip__text:after {
          border-style: solid;
          border-width: 0 10px 10px;
          content: '';
          display: block;
          left: calc(50% - -18px);
          position: absolute;
        }
        .tool-tip__text:before {
          border-color: ${theme.colors.white} transparent;
          top: -10px;
          width: 8px;
          z-index: 0;
        }
        .tool-tip__text:after {
          border-color: ${theme.colors.primary} transparent;
          top: -8px;
          width: 0;
          z-index: 1;
        }
        .tool-tip:hover .tool-tip__text,
        .tool-tip__text.tool-tip__is-enabled {
          visibility: visible;
        }
        .tool-tip:hover .tool-tip__text.tool-tip__is-enabled {
          visibility: hidden;
        }
        @media (max-width: ${theme.breakpoints.mdDown}) {
          .tool-tip__text:before,
          .tool-tip__text:after {
            border-width: 10px 10px 0;
            top: initial;
          }
          .tool-tip__text:before {
            bottom: -10px;
          }
          .tool-tip__text:after {
            bottom: -8px;
          }
        }
        @media (min-width: ${theme.breakpoints.mdUp}) {
          .tool-tip__text {
            top: 28px;
          }
        }
      `}</style>
    </>
  );
};

Tooltip.propTypes = {
  children: PropTypes.node,
  extraClasses: PropTypes.string,
  iconText: PropTypes.string,
};

Tooltip.defaultProps = {
  iconText: 'i',
};

export default Tooltip;
